import Button from "../../../../components/Button/Button";
import { Section, Card, FieldGrid, Field } from "./accountParts";

const LogoPreview = ({ url }) =>
  url ? (
    <img
      src={url}
      alt="Account logo"
      className="max-h-16 rounded border border-gray-200 bg-white object-contain p-1"
    />
  ) : (
    <span className="text-gray-900">—</span>
  );

const ProfileSettingsCard = ({ profile, canEdit, onEdit }) => (
  <Section
    title="Profile Settings"
    actions={
      canEdit && (
        <Button size="sm" onClick={onEdit}>
          Update
        </Button>
      )
    }
  >
    <Card>
      <FieldGrid>
        <Field label="Name" value={profile?.legal_name} />
        <Field label="PAN / Tax Number" value={profile?.tax_number} />
        <Field label="GSTIN / VAT Number" value={profile?.vat_number} />
        <Field
          label="Website"
          value={
            profile?.website ? (
              <a
                href={
                  /^https?:\/\//i.test(profile.website)
                    ? profile.website
                    : `https://${profile.website}`
                }
                target="_blank"
                rel="noopener noreferrer"
                className="text-brand-600 hover:underline"
              >
                {profile.website}
              </a>
            ) : null
          }
        />
        <Field label="Country" value={profile?.country} />
        <Field label="State / Province / Region" value={profile?.state_region} />
        <Field label="City" value={profile?.city} />
        <Field label="Postal / ZIP Code" value={profile?.postal_code} />
        <Field label="Address" value={profile?.address} />
        <Field label="Logo" value={<LogoPreview url={profile?.logo_url} />} />
      </FieldGrid>
    </Card>
  </Section>
);

export { LogoPreview };
export default ProfileSettingsCard;
